module.exports = __webpack_public_path__ + "static/media/crud_usuario_update.700b3873.png";